import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import PageMeta from '../components/PageMeta';
import Reveal from '../components/Reveal';
import LeadForm from '../components/LeadForm';
import { CheckList } from '../components/SharedSections';

const { FiFileText, FiSearch, FiMap, FiClock } = FiIcons;

function RealityCheck() {
  return (
    <>
      <PageMeta title="Free Tech Reality Check™" description="Get a free review of your communications and wireless costs, capability gaps, and best next step." />
      <section className="assessment-hero">
        <div className="assessment-grid">
          <Reveal>
            <span className="eyebrow light">Cambia’s flagship free assessment</span>
            <h1>Know what’s working, what’s costing you, and what to do next.</h1>
            <p>The Tech Reality Check™ turns unclear bills, overlapping tools, and vendor claims into a practical decision framework.</p>
            <CheckList items={['No obligation to switch providers', 'Independent review across the market', 'Built for SMB owners, IT, and operations leaders', 'A clear output—not another generic sales demo']} />
            <div className="assessment-timing"><SafeIcon icon={FiClock} /><span><strong>30-minute discovery</strong> followed by a focused review</span></div>
          </Reveal>
          <Reveal className="assessment-form-card">
            <h2>Request your free assessment</h2>
            <p>Prefer to skip the form? <a className="text-link" href="https://meet.cambiadigital.com/consult" target="_blank" rel="noopener noreferrer">Book a time directly on our calendar</a>.</p>
            <LeadForm name="tech-reality-check" />
          </Reveal>
        </div>
      </section>
      <section className="section">
        <div className="card-grid three">
          {[[FiFileText, 'Current-state snapshot', 'A clear inventory of services, contracts, costs, and avoidable overlap.'], [FiSearch, 'Gap and savings analysis', 'Specific areas where capability, support, or spend is out of alignment.'], [FiMap, 'Recommended path', 'A practical shortlist and next steps, including when staying put is the right answer.']].map(([icon, title, text]) => <Reveal className="solution-card" key={title}><div className="icon-tile"><SafeIcon icon={icon} /></div><h3>{title}</h3><p>{text}</p></Reveal>)}
        </div>
      </section>
    </>
  );
}

export default RealityCheck;